import { useAuthService } from "@/hooks/useAuthService/useAuthService";
import type { StateType } from "../../../types";

type Props = {
	states: StateType[];
	name: string;
};

export function useCanUpdateOrSave(props: Props) {
	const { states = [], name } = props;
	const authService = useAuthService();

	const canUpdate = states.some((item) => item.itemName === name);
	const canSave = states.length < authService.savedStateLimit;

	return {
		canUpdate,
		canSave,
	};
}
